export default __webpack_public_path__ + "static/media/c6.96c9bad0.jpg";